const COURSE_STEP_NUMBERS = {
  REGISTRATION: 1,
  STUDING: 2,
  EXAM: 3,
  PASSED: 4,
};

function hasPendingQuestionnaire(examItem) {
  const originExam = examItem && examItem.originExam;
  return originExam && originExam.hasPendingQuestionnaire === true;
}

function resolveCourseDetailStep({
  displayStep,
  routeStep,
  hasPendingQuestionnaire: hasPending,
}) {
  if (hasPending) {
    return COURSE_STEP_NUMBERS.EXAM;
  }

  const parsedRouteStep = Number.parseInt(routeStep, 10);
  if (parsedRouteStep >= 1 && parsedRouteStep <= 4) {
    return parsedRouteStep;
  }

  return COURSE_STEP_NUMBERS[displayStep] || COURSE_STEP_NUMBERS.REGISTRATION;
}

function isExamActionDisabled(examItem) {
  const originExam = examItem && examItem.originExam;
  const originExamNeedCam = originExam && originExam.needCam;
  const hasRetryTimes =
    examItem &&
    examItem.maxRetryTimes !== undefined &&
    examItem.maxRetryTimes !== null &&
    examItem.maxRetryTimes > 0;

  if (hasPendingQuestionnaire(examItem)) {
    return false;
  }

  if (hasRetryTimes) {
    return (
      originExamNeedCam === true || (examItem && examItem.status === false)
    );
  }

  if (examItem && examItem.examPass) {
    return true;
  }

  const studentExamStatus =
    (examItem && examItem.studentExamStatus) ||
    (originExam && originExam.status);
  if (
    studentExamStatus === "done" ||
    studentExamStatus === "graded" ||
    studentExamStatus === "terminated"
  ) {
    return true;
  }

  return originExamNeedCam === true || (examItem && examItem.status === false);
}

function getExamButtonText(examItem) {
  if (hasPendingQuestionnaire(examItem)) {
    return "去填写问卷";
  }

  if (examItem && examItem.originExam && examItem.originExam.needCam) {
    return "当前考试不支持使用手机考试";
  }

  const maxRetryTimes = examItem && examItem.maxRetryTimes;
  if (
    maxRetryTimes !== undefined &&
    maxRetryTimes !== null &&
    maxRetryTimes > 0
  ) {
    return `去考试（剩余考试机会${maxRetryTimes}次）`;
  }

  if (examItem && examItem.examPass) {
    return "已考完";
  }

  if (
    maxRetryTimes !== undefined &&
    maxRetryTimes !== null &&
    maxRetryTimes <= 0
  ) {
    return "已考完";
  }

  return "去考试";
}

module.exports = {
  getExamButtonText,
  hasPendingQuestionnaire,
  isExamActionDisabled,
  resolveCourseDetailStep,
};
